import React from 'react';
import { TimeInput } from './TimeInput';

const getEventSpecTexts = (eventType, eventSchedule = null) => {
  switch (eventType) {
    case 'regular_hours':
      return {
        title: "Öffnungszeiten",
        subtitle: "Diese Öffnungszeiten wurden erfasst."
      };

    case 'recurring_event':
      const frequency = eventSchedule?.recurrence_pattern?.frequency;
      
      if (frequency === 'daily') {
        return {
          title: "Tägliche Wiederholung",
          subtitle: "Uhrzeit bzw. Gültigkeitszeitraum."
        };
      } else if (frequency?.startsWith('monthly_')) {
        return {
          title: "Monatliche Wiederholung",
          subtitle: "Wochentag, Rhythmus und Uhrzeit bzw. Gültigkeitszeitraum."
        };
      } else {
        return {
          title: "Wöchentlich wiederkehrende Termine",
          subtitle: "Wochentag, Uhrzeit bzw. Gültigkeitszeitraum und Wiederholungsmuster."
        };
      }

    case 'single_event':
      const eventCount = eventSchedule?.dates?.length || 1;
      
      if (eventCount === 1) {
        return {
          title: "Termin",
          subtitle: "Datum und Uhrzeit der Aktivität."
        };
      } else {
        return {
          title: "Event-Termine",
          subtitle: "Datum und Uhrzeit jeder Aktivität."
        };
      }

    case 'multi_day':
      return {
        title: "Mehrtägiger Event",
        subtitle: "Daten und Uhrzeit bzw. Zeitraum der Aktivität."
      };

    case 'freely_accessible':
      const isSeasonal = eventSchedule?.is_seasonal || 
                        (eventSchedule?.accessible_from && eventSchedule?.accessible_until);
      
      if (isSeasonal) {
        return {
          title: "Zeitraum",
          subtitle: "Prüfen Sie den Zeitraum, in dem die Aktivität zugänglich ist."
        };
      } else {
        return {
          title: "Jederzeit zugänglich",
          subtitle: "Diese Aktivität hat keine zeitlichen Einschränkungen."
        };
      }

    default:
      return {
        title: "Zeitangaben",
        subtitle: "Überprüfen Sie alle zeitlichen Angaben."
      };
  }
};

const DateTimeReportLine = ({ label, dayData, onAdd, onRemove, onUpdate }) => (
  <div className="event-type-entry">
    <div className="day-header">
      <label>
        <input
          type="checkbox"
          checked={!!dayData}
          onChange={(e) => e.target.checked ? onAdd() : onRemove()}
        />
        <span className="day-name">{label}</span>
      </label>
    </div>

    {dayData && (
      <div className="day-times">
        <span>{dayData.closes ? 'von' : 'um'}</span>
        <TimeInput
          value={dayData.opens || ''}
          onChange={(e) => onUpdate('opens', e.target.value)}
          className="time-input text__input"
        />
        {dayData.closes && (
          <>
            <span>bis</span>
            <TimeInput
              value={dayData.closes}
              onChange={(e) => onUpdate('closes', e.target.value)}
              className="time-input text__input"
            />
          </>
        )}
      </div>
    )}
  </div>
);

export default DateTimeReportLine;
